import gettext from '@sdk/lang/gettext';

import AnnouncementViewsEmptyStateSvg from '@web/assets/svg/Misc/empty-announcement-views-state.svg';

import { Wrapper } from './emptyAnnouncementViews.styles';

export const EmptyAnnouncementViews = () => (
  <Wrapper data-testid="empty-annoucement-views">
    <AnnouncementViewsEmptyStateSvg aria-hidden="true" />
    {gettext('Nobody has seen your announcement yet. ')}
  </Wrapper>
);
